/** Presentation-local quick-fact icons — existing FontAwesome classes only. */
export const PRESENTATION_FACT_ICONS = {
  total_area_m2: "fa-solid fa-vector-square",
  living_area_m2: "fa-solid fa-vector-square",
  kitchen_area_m2: "fa-solid fa-utensils",
  rooms: "fa-solid fa-door-open",
  bathrooms: "fa-solid fa-bath",
  floor: "fa-solid fa-stairs",
  total_floors: "fa-solid fa-building",
  land_area_m2: "fa-solid fa-vector-square",
  area_m2: "fa-solid fa-vector-square",
  purpose: "fa-solid fa-tag",
  suitable_for: "fa-solid fa-briefcase",
  year_built: "fa-solid fa-calendar",
  walls: "fa-solid fa-building",
  heating: "fa-solid fa-fire",
  condition: "fa-solid fa-wrench",
  furniture: "fa-solid fa-chair",
};

export function presentationFactIcon(key) {
  return PRESENTATION_FACT_ICONS[key] || "fa-solid fa-circle-info";
}
